let domain = "www.maoistore.com";

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    domain = "http://localhost:3000";
}

export default domain;